var Modal = require("components/utility/AltModal");

require("writing/questions/speech_controls.scss");

class SpeechControls extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = { isSpeaking: false, isWaiting: false, recognition: false, 
			showSpeechToTextHelpModal: false 
		};
	}
	componentDidMount() {
		if (!this.props.readTextOnly) {
			var sources = [
				{ "ref": "start_recording", "path": "speech-to-text/start_recording", "play": false },
				{ "ref": "end_recording", "path": "speech-to-text/end_recording", "play" :false }
			]
			window.wrL2eSound.addSource(sources,"speech_control");
		}
		if (this.props.autoReadText) {
			this.readQuestion();
		}
	}
	createVoice(text) {
		var u = new SpeechSynthesisUtterance();
		u.text = text;
		u.voiceURI = 'native';
		u.lang = 'en-US';
		u.rate = 1;
		u.pitch = 1.1;
		u.onstart = this.startSpeaking;
		u.onend = this.stopSpeaking;

		return u;
	}

	startSpeaking() {
		this.animateSpeechIcon();
		this.setState({ isWaiting: false, isSpeaking: true });
	}

	stopSpeaking() {
		this.setState({ isSpeaking: false });
	}

	recordAnswer() {
		if (!window.speechSynthesis) {
			return;
		}
		if (this.state.isSpeaking) {
			window.speechSynthesis.cancel();
		}

		if (this.state.isRecording) {
			// this.onStopRecording();
			this.state.recognition.stop();
		} else {
			this.startRecording();
		}
	}

	startRecording() {
		var recognition = new webkitSpeechRecognition();
		recognition.continuous = true;
		recognition.interimResults = true;

		var text = this.props.getText();
		if (text.length > 0) {
			var final_transcript = text + " ";
		} else {
			var final_transcript = "";
		}
		
		recognition.onstart = this.onStartRecording;
		recognition.onresult = function(event) {
			var interim_transcript = '';
			for (var i = event.resultIndex; i < event.results.length; ++i) {
				if (event.results[i].isFinal) {
					final_transcript += event.results[i][0].transcript;
					this.props.setText(final_transcript);
				} else {
					interim_transcript += event.results[i][0].transcript;
					this.props.setText(final_transcript + interim_transcript);
				}
			}
		}.bind(this);
		recognition.onend = this.onStopRecording;
		recognition.start();

		this.setState({ isWaiting: true, isRecording: true, recognition: recognition });
	}

	onStartRecording() {
		this.triggerSoundStartRecording();
		this.animateRecordingIcon();
		this.setState({ isWaiting: false, isRecording: true });
	}

	onStopRecording() {
		this.triggerSoundStopRecording();
		this.setState({ isRecording: false });
	}

	animateRecordingIcon() {
		$(this.refs.speechToText).css("background-color",'#bbbbbb');
		if (this.props.toggleHighlight) {  this.props.toggleHighlight(true, "recording"); }

		setTimeout(function() {
			$(this.refs.speechToText).css("background-color",'#da3956');
			if (this.props.toggleHighlight) {  this.props.toggleHighlight(false, "recording"); }

		}.bind(this), 1000);

		setTimeout(function() {
			if (this.state.isRecording) {
				this.animateRecordingIcon();
			} else {
				$(this.refs.speechToText).css("background-color",'');
				if (this.props.toggleHighlight) {  this.props.toggleHighlight(false, "recording");}
			}
		}.bind(this), 2000);
	}

	animateSpeechIcon() {
		$(this.refs.textToSpeech).css("background-color",'#bbbbbb');
			if (this.props.toggleHighlight) {  this.props.toggleHighlight(true, "textToSpeechHighlight"); }

		setTimeout(function(){ 
			$(this.refs.textToSpeech).css("background-color",'#8e54c1');
			if (this.props.toggleHighlight) {  this.props.toggleHighlight(false, "textToSpeechHighlight"); }
		}.bind(this), 1000);

		setTimeout(function(){ 
			if (this.state.isSpeaking) {
				this.animateSpeechIcon();
			} else {
				$(this.refs.textToSpeech).css("background-color",'');
				if (this.props.toggleHighlight) {  this.props.toggleHighlight(false, "textToSpeechHighlight"); }
			}
		}.bind(this), 2000);
	}

    triggerSoundStartRecording() {
    	window.wrL2eSound.stopAllSounds()
		window.wrL2eSound.playSound("start_recording" + "_speech_control" )
	}

	triggerSoundStopRecording() {
		window.wrL2eSound.stopAllSounds()
		window.wrL2eSound.playSound("end_recording" + "_speech_control" )
	}

	readQuestion() {
		if (!window.speechSynthesis) {
			return;
		}
		if (this.state.isRecording) {
			this.onStopRecording();
		}

		if (this.state.isSpeaking) {
			window.speechSynthesis.cancel();

		} else if (window.speechSynthesis) {
			this.setState({ isWaiting: true }, this.breakAndReadText);

		} else {
			window.wrNotifications.triggerDropDownNotification({
				title: "Sorry!", text: "Reading out loud doesn't work in your browser. Please use the latest version of Chrome, Firefox, or Safari.", 
				icon: "exclamation-sign", type: "error", 
			}, 6000);
		}
	}

	breakAndReadText() {
		if (!window.speechSynthesis) {
			return;
		}
		window.speechSynthesis.cancel();
		window.wrVoice = window.wrVoice || [];

		var text = this.props.getTextToRead();
		text = text.replace("____", "... ... ... ...");

		var voice = this.createVoice(text);
		window.wrVoice.push(voice);

		setTimeout(function() {
			window.speechSynthesis.speak(voice);
		}.bind(this), 150);
	}

	openSpeechToTextHelpModal(e) {
		$wr.nope(e)
		this.refs.modal.show();
	}

	render() {
		if (this.state.isWaiting) {
			// We clicked a button and it is loading
			var statusMessage = (
				<em>Loading... </em>
			);
		}

		// Text-to-voice
		var textToSpeech = (
			<img className="textToSpeech" ref='textToSpeech' onClick={ this.readQuestion }
				src={ require('misc/text-to-speech.png') } />
		);
		if ($wr.isIOS() && this.props.autoReadText) {
			// It won't actually autoread, so we need alert the user
			var statusMessage = (
				<em>Tap to read: {" "}</em>				
			);
		}

		// Voice-to-text
		if (!this.props.readTextOnly) {
			// When voice-to-text should be included

			if ('webkitSpeechRecognition' in window) {
				// Currently just chrome
				var speechToText = (
					<img className="speechToText" ref='speechToText' onClick={ this.recordAnswer }
						src={ require('misc/speech-to-text.png') } />
				);

			} else {
				// Anything other than chrome, basically

				if ($wr.isIOS()) {
					// iOS/iPad give dication instructions
					var speechToText = (
						<img className="speechToText" ref='speechToText' onClick={ this.openSpeechToTextHelpModal }
							src={ require('misc/speech-to-text.png') } />
					);
					var iosModal = (
						<Modal className="textToSpeechModal" ref="modal" headerText="Text to Speech">
							<div className="modalBody">
								<p>Want to speak instead of typing? Tap the text area (where your answer goes) and then the microphone on your keyboard and get started!</p>
								<img className="keyboardImg" src={require("misc/text_to_speech_keyboard.png")} />
							</div>
						</Modal>
					);

				} else {
					// Old FF, IE, tell them to use chrome
					var speechToText = (
						<img className="speechToText" ref='speechToText'
							src={ require('misc/speech-to-text.png') } />
					);
					var useChrome = (
						<span className="chromeTip">To record your answer, use Chrome!</span>
					);
				}
			}
		}

		var speechClassName = "speechControlsContainer";
		if (!(useChrome || statusMessage)) {
			speechClassName += " text-center";
		}

		return (
			<div className={ speechClassName }>
				{ statusMessage }
				{ textToSpeech }
				{ speechToText }
				{ useChrome }
				{ iosModal }
			</div>
		);

	}

	componentWillUnmount() {
		if (!this.props.readTextOnly) {
			window.wrL2eSound.removeSources('speech_control');
			if (this.state.recognition) {
				this.state.recognition.stop();
			}
		}
	}
}


SpeechControls.propTypes = StrictPropTypes({
	// Gets the existing text that voice will append to, required if readTextOnly is false
	getText: PropTypes.func,

	// Sets the text from voice recording, required if readTextOnly is false
	setText: PropTypes.func,

	// Gets the text to read out loud
	getTextToRead: PropTypes.func.isRequired,

	// Toggles the highlight during recording
	toggleHighlight: PropTypes.func,

	// Automatically read the text
	autoReadText: PropTypes.bool,

	// If true, read text only, no voice recording
	readTextOnly: PropTypes.bool,
});

module.exports = SpeechControls;


// WEBPACK FOOTER //
// ./modules/components/writing/questions/SpeechControls.js